module.exports = __webpack_public_path__ + "img/logo-strip.afe59bad.jpg";